import React from "react";

import {
  CADENCE_SOLID_COLOR,
  CadenceKey,
} from "../../Utils/Guidance/guidanceCadence";

interface GuidanceLetsGoButtonProps {
  cadenceKey: CadenceKey;
  onClick: () => void;
  className?: string;
}

const GuidanceLetsGoButton: React.FC<GuidanceLetsGoButtonProps> = ({
  cadenceKey,
  onClick,
  className = "",
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`shrink-0 text-sm font-semibold text-white rounded-lg px-5 py-2.5 leading-tight text-center transition-[filter] hover:brightness-95 ${className}`.trim()}
    style={{ backgroundColor: CADENCE_SOLID_COLOR[cadenceKey] }}
  >
    Let&apos;s Go
  </button>
);

export default GuidanceLetsGoButton;
